module.exports = __webpack_public_path__ + "img/dat09.16ce0d45.png";